import React, { useEffect, useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ClockIcon } from 'lucide-react';
import { trackEvent } from '../hooks/useMetaPixel';
function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = localStorage.getItem('suavidad-countdown-end');
    if (saved) {
      const remaining = Math.max(0, Math.floor((parseInt(saved) - Date.now()) / 1000));
      if (remaining > 0) return remaining;
    }
    // 48 hours in seconds
    const duration = 48 * 60 * 60;
    localStorage.setItem('suavidad-countdown-end', String(Date.now() + duration * 1000));
    return duration;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className="mb-8" data-id="element-100">
      <div className="flex items-center justify-center gap-2 mb-3" data-id="element-101">
        <ClockIcon className="w-4 h-4 text-rose animate-pulse" data-id="element-102" />
        <p className="text-sm text-rose font-bold uppercase tracking-widest" data-id="element-103">
          Esta oferta expira en
        </p>
      </div>
      <div className="flex items-center justify-center gap-3" data-id="element-104">
        <div className="bg-brown text-cream rounded-2xl px-4 py-3 min-w-[72px] shadow-lg" data-id="element-105">
          <span className="text-3xl md:text-4xl font-serif font-bold block leading-none" data-id="element-106">
            {pad(hours)}
          </span>
          <span className="text-[10px] uppercase tracking-widest text-cream/60 mt-1 block" data-id="element-107">
            Horas
          </span>
        </div>
        <span className="text-2xl font-serif text-brown/40 font-bold" data-id="element-108">:</span>
        <div className="bg-brown text-cream rounded-2xl px-4 py-3 min-w-[72px] shadow-lg" data-id="element-109">
          <span className="text-3xl md:text-4xl font-serif font-bold block leading-none" data-id="element-110">
            {pad(minutes)}
          </span>
          <span className="text-[10px] uppercase tracking-widest text-cream/60 mt-1 block" data-id="element-111">
            Min
          </span>
        </div>
        <span className="text-2xl font-serif text-brown/40 font-bold" data-id="element-112">:</span>
        <div className="bg-brown text-cream rounded-2xl px-4 py-3 min-w-[72px] shadow-lg" data-id="element-113">
          <span className="text-3xl md:text-4xl font-serif font-bold block leading-none" data-id="element-114">
            {pad(seconds)}
          </span>
          <span className="text-[10px] uppercase tracking-widest text-cream/60 mt-1 block" data-id="element-115">
            Seg
          </span>
        </div>
      </div>
    </div>;
}
export function OfferSection() {
  const handleBuyClick = () => {
    trackEvent('InitiateCheckout', {
      content_name: 'Reconecta con tu Energía Femenina',
      content_type: 'product',
      value: 6.39,
      currency: 'USD'
    });
  };
  return <section id="offer-section" className="py-24 bg-cream relative overflow-hidden" data-id="element-116">
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-gold-light/10 rounded-full blur-3xl -z-10" data-id="element-117" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-118">
        <FadeIn data-id="element-119">
          <div className="bg-white rounded-[3rem] p-8 md:p-16 shadow-2xl shadow-brown/5 border border-gold/20 relative" data-id="element-120">
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-brown text-cream px-6 py-2 rounded-full text-sm font-bold tracking-widest uppercase shadow-lg" data-id="element-121">
              Oferta Especial
            </div>

            <h2 className="text-4xl md:text-5xl font-serif text-brown mb-6 mt-4" data-id="element-122">
              Tu Transformación Comienza Hoy
            </h2>

            <p className="text-xl text-brown/80 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-123">
              Hoy puedes obtener el sistema completo "Reconecta con tu Energía
              Femenina" junto con todos los bonus prácticos por una fracción de
              lo que cuesta una sesión de terapia de una hora.
            </p>

            <CountdownTimer data-id="element-124" />

            <div className="mb-10" data-id="element-125">
              <p className="text-sm text-brown/60 uppercase tracking-widest font-bold mb-2" data-id="element-126">
                Inversión Única
              </p>
              <div className="flex items-center justify-center gap-4" data-id="element-127">
                <span className="text-3xl md:text-4xl font-serif text-brown/40 line-through decoration-rose/60 decoration-2" data-id="element-128">
                  $19.99
                </span>
                <span className="text-6xl md:text-7xl font-serif text-gold-dark font-bold" data-id="element-129">
                  $6.39
                </span>
                <span className="text-2xl text-brown/60 mt-4" data-id="element-130">USD</span>
              </div>
              <div className="mt-3 inline-block bg-rose-light/30 text-brown-light px-4 py-1 rounded-full text-sm font-bold tracking-wide" data-id="element-131">
                68% DE DESCUENTO
              </div>
            </div>

            <Button size="lg" href="https://pay.hotmart.com/B104470392R" onClick={handleBuyClick} className="w-full md:w-auto md:px-12 py-5 text-lg shadow-xl shadow-gold/30" data-id="element-132">
              COMPRAR AHORA
            </Button>

            <p className="mt-6 text-sm text-brown/60 font-medium" data-id="element-133">
              (Empieza tu transformación ahora mismo)
            </p>

            <div className="mt-8 flex items-center justify-center space-x-4 text-brown/40" data-id="element-134">
              <span className="text-sm" data-id="element-135">✓ Acceso Inmediato</span>
              <span data-id="element-136">•</span>
              <span className="text-sm" data-id="element-137">✓ Pago 100% Seguro</span>
              <span data-id="element-138">•</span>
              <span className="text-sm" data-id="element-139">✓ Formato Digital</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}